export default {
  async asyncData({ store, params }) {
    try {
      await store.dispatch('rph-products/getProductBySlug', {
        slug: params.product ? params.product : params.slug,
        category: params.category ? params.category : 'product',
        params: {
          params: {
            expand:
              'annotation,images,specification,prices,producers,seo,extra,category,trade_name,analogues',
          },
        },
      })
    } catch (error) {
      console.log(error)
    }
    await store.dispatch('rph-categories/getCategoryBySlug', {
      slug: params?.category
        ? params?.category
        : store.getters['rph-products/product'].category?.slug,
      params: {
        params: { expand: 'parents' },
      },
    })
  },
  head() {
    const structuredData = [
      { innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' },
      { innerHTML: JSON.stringify(this.structuredImage), type: 'application/ld+json' },
    ]

    if (this.reviews.length)
      structuredData.push({
        innerHTML: JSON.stringify(this.structuredReviews),
        type: 'application/ld+json',
      })
    return {
      title: this.seo?.title,
      meta: this.$services.head.createMeta({
        title: this.seo?.title,
        description: this.seo?.description,
        keywords: this.seo?.keywords,
        ogImage: this.seo?.og_image,
      }),
      link: [this.$services.head.createCanonicalLink(this.$route.path)],
      __dangerouslyDisableSanitizers: ['script'],
      script: structuredData,
    }
  },
  async mounted() {
    const { params } = this.$route
    await Promise.all([
      this.$store.dispatch('rph-products/getRecommendedProducts', {
        params: {
          product_id: this.$store.getters['rph-products/product'].id,
          limit: 5,
          expand: 'images,specification,prices,producers,extra,category',
        },
      }),
      this.$store.dispatch('rph-reviews/getReviews', {
        params: {
          params: {
            'filter[object]': 'product',
            'filter[object_id]': this.$store.getters['rph-products/product'].id,
          },
        },
      }),
    ])
  },
  computed: {
    seo() {
      return this.product.seo
    },
    product() {
      return this.$store.getters['rph-products/product']
    },
    openAdultModal() {
      return this.$store.getters['rph-modals/adultConfirmModal']
    },
    categoryBySlug() {
      return this.$store.getters['rph-categories/categoryBySlug']
    },
    availablePrice() {
      return this.product ? this.$services.price.getDefaultPrice(this.product.prices) : ''
    },
    reviews() {
      return this.$store.getters['rph-reviews/reviews']
    },
    structuredData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        description: `${Object.values(this.product.annotation)
          .filter((value) => value)
          .join(' ')}`,
        name: this.product ? this.product.title : '',
        image:
          this.product && this.product.images.length ? this.product.images[0].links.medium : '',
        offers: {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price:
            this.product && this.availablePrice.length
              ? this.product.prices[this.availablePrice].price
              : '',
          priceCurrency: 'KZT',
          seller: {
            '@type': 'Organization',
            '@id': 'https://aurma.kz/',
            name: 'Aurma.kz',
            url: 'https://aurma.kz/',
          },
        },
        category: this.product?.category?.title,
        manufacturer: {
          '@type': 'Organization',
          name: this.product?.producers.title,
        },
        countryOfOrigin: {
          '@type': 'Country',
          name: this.product?.specification?.country,
        },
        gtin: this.product?.specification?.barcode,
      }
    },
    structuredImage() {
      return {
        '@context': 'https://schema.org',
        '@type': 'ImageObject',
        contentUrl:
          this.product && this.product.images.length ? this.product.images[0].links.medium : '',
        name: this.product ? this.product.title : '',
      }
    },
    structuredReviews() {
      return this.reviews.map((review) => {
        return {
          '@context': 'https://schema.org',
          '@type': 'Review',
          reviewBody: review.content,
          reviewRating: {
            '@type': 'Rating',
            worstRating: '1',
            bestRating: '5',
            ratingValue: review.rate,
          },
          author: {
            '@type': 'Person',
            name: review?.user?.name ?? '',
          },
          itemReviewed: {
            '@type': 'Product',
            name: this.product.title,
          },
        }
      })
    },
  },
}
